import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    current: [],
    progressChangeList: [],
    progressChangeCurrent: {}
  },
  getters: {
    scheduleIncludeToday (state, getters, rootState) {
      let progress = state.current.slice()
      progress.unshift({
        actualRate: 0,
        start: new Date(rootState.project.current.beginAt),
        rate: '0',
        realRate: '0',
        sumRate: '0',
        end: new Date(rootState.project.current.beginAt)
      })

      const todayIndex = progress.findIndex(p => new Date(p.start) < new Date() && new Date() < new Date(p.end))

      if (todayIndex !== -1) {
        const today = {
          actualRate: progress[todayIndex].actualRate,
          end: new Date().toISOString(),
          rate: progress[todayIndex].rate * (new Date().getTime() - new Date(progress[todayIndex].start).getTime()) / (new Date(progress[todayIndex].end).getTime() - new Date(progress[todayIndex].start).getTime()),
          start: new Date().toISOString()
        }
        today.sumRate = (parseFloat(progress[todayIndex - 1].sumRate) + today.rate).toFixed(2).toString()
        today.rate = today.rate.toFixed(2).toString()
        progress.splice(todayIndex, 0, today)

        progress[todayIndex + 1].actualRate = null
      }

      return progress
    }
  },
  mutations: {
    setCurrent (state, current) {
      state.current = current

      for (let index = 0; index < state.current.length; index++) {
        const progress = state.current[index]

        progress.realRate = progress.actualRate
          ? (parseFloat(progress.actualRate) - ((state.current[index - 1] && parseFloat(state.current[index - 1].actualRate)) || 0)).toFixed(2)
          : null

        progress.status = progress.actualRate
          ? (progress.actualRate - progress.sumRate).toString()[0] !== '-'
            ? '+' + (progress.actualRate - progress.sumRate).toString()
            : (progress.actualRate - progress.sumRate).toString()
          : null
      }
    },
    setProgressChangeList (state, currentList) {
      state.progressChangeList = currentList
    },
    setProgressChangeCurrent (state, current) {
      state.progressChangeCurrent = current
    }
  },
  actions: {
    async getScheduleAndStore ({rootState, commit}, isActual) {
      const result = await api.getSchedule(rootState.project.current._id, isActual)

      commit('setCurrent', result)
    },
    async addSchedule ({rootState, commit, dispatch}, condition) {
      await api.addSchedule(rootState.project.current._id, condition)
      await dispatch('getScheduleAndStore')
    },
    async getProgressChangeAndStore ({rootState, commit, dispatch}) {
      const result = await api.getProgressChangeList(rootState.project.current._id)
      commit('setProgressChangeList', result)
    },
    async getProgressChange ({rootState, commit, dispatch}, progressChangeId) {
      const result = await api.getProgressChange(rootState.project.current._id, progressChangeId)
      commit('setProgressChangeCurrent', result)
    },
    async updateProgressChange ({rootState, commit, dispatch, state}, condition) {
      await api.updateProgressChange(rootState.project.current._id, state.progressChangeCurrent._id, condition)
      await dispatch('getScheduleAndStore')
    },
    async deleteSchedule ({ rootState, dispatch }, progressChangeId) {
      await api.deleteSchedule(rootState.project.current._id, progressChangeId)
      await dispatch('getProgressChangeAndStore')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/schedule.js